import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['group-right', {
      'flexReverse': $props.reverse
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['dot']),
    style: _normalizeStyle($options.isHeighter.iconstyle)
  }, null, 4), _createElementVNode("span", {
    style: _normalizeStyle($options.isHeighter.textStyle)
  }, _toDisplayString($options.isHeighter.text), 5)], 2);
}